// extracted by mini-css-extract-plugin
export var badge = "_gz-2";
export var detailsPanel = "_gz-0";
export var resultRow = "_gz-1";